import Vue from "vue";
import App from "./App.vue";
import VueScrollactive from "vue-scrollactive";

import "bootstrap/dist/css/bootstrap.css";
import 'jquery/src/jquery.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import "font-awesome/css/font-awesome.min.css";
import "./assets/css/main.scss";

Vue.config.productionTip = false;
Vue.use(VueScrollactive);
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
